import { useEffect, lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";

const LinesPage = lazy(() => import("@/pages/LinesPage"));
const CoverageDetail = lazy(() => import("@/pages/CoverageDetail"));
const IndustryDetail = lazy(() => import("@/pages/IndustryDetail"));
const Quote = lazy(() => import("@/pages/Quote"));
const PolicyReview = lazy(() => import("@/pages/PolicyReview"));
const Claims = lazy(() => import("@/pages/Claims"));
const Certificate = lazy(() => import("@/pages/Certificate"));
const Pay = lazy(() => import("@/pages/Pay"));
const WhyUs = lazy(() => import("@/pages/WhyUs"));
const Login = lazy(() => import("@/pages/Login"));
const Portal = lazy(() => import("@/pages/Portal"));
const Apply = lazy(() => import("@/pages/Apply"));
const ApplyGL = lazy(() => import("@/pages/ApplyGL"));
const ApplyLine = lazy(() => import("@/pages/ApplyLine"));
const Admin = lazy(() => import("@/pages/Admin"));
const Privacy = lazy(() => import("@/pages/legal/Privacy"));
const Terms = lazy(() => import("@/pages/legal/Terms"));
const Accessibility = lazy(() => import("@/pages/legal/Accessibility"));

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Layout>
        <Suspense fallback={<div className="wrap py-24" aria-busy="true" />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/business" element={<LinesPage side="business" />} />
          <Route path="/personal" element={<LinesPage side="personal" />} />
          <Route path="/specialty" element={<LinesPage side="specialty" />} />
          <Route path="/coverage/:slug" element={<CoverageDetail />} />
          <Route path="/industries/:slug" element={<IndustryDetail />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/apply/general-liability" element={<ApplyGL />} />
          <Route path="/apply/:slug" element={<ApplyLine />} />
          <Route path="/policy-review" element={<PolicyReview />} />
          <Route path="/claims" element={<Claims />} />
          <Route path="/certificate" element={<Certificate />} />
          <Route path="/pay" element={<Pay />} />
          <Route path="/why-us" element={<WhyUs />} />
          <Route path="/login" element={<Login />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </Suspense>
        </Layout>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
